import React, { FC, useState } from 'react'
import { isMobile } from 'react-device-detect'

import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'

import {
  WizzardPaginationBox,
  WizzardPaginationRange,
} from '../style/UserWIzzardStyle'

interface WizzardPaginationInterface {
  page: number
}

const WizzardPagination: FC<WizzardPaginationInterface> = ({ page }) => {
  return (
    <WizzardPaginationBox>
      <GenericTextSpan
        opacity={'0.5'}
        fSize={!isMobile ? '0.8rem' : '1.4rem'}
        margin={'0 0 2% 0'}
      >
        Krok {page + 1} z 7
      </GenericTextSpan>
      <WizzardPaginationRange page={page} />
    </WizzardPaginationBox>
  )
}

export default WizzardPagination
